import { format } from 'date-fns'

import { fromDateString } from '../../lib/shared/calendar.utils'

interface AccountingYearSettingsProps {
  accountingReferenceDate: string
}

export function AccountingYearSettings({
  accountingReferenceDate,
}: AccountingYearSettingsProps) {
  const formatDate = (dateString: string) => {
    try {
      const date = fromDateString(dateString)
      return format(date, 'dd MMMM')
    } catch {
      return 'Not set'
    }
  }

  return (
    <div className="mt-6 border-t border-gray-100 pt-6">
      <h3 className="text-xl font-medium text-gray-900">Accounting Year</h3>
      <div className="mt-2">
        <p className="text-sm text-gray-500">
          Your accounting year ends:{' '}
          <span className="font-medium text-gray-900">
            {formatDate(accountingReferenceDate)}
          </span>
        </p>
      </div>
    </div>
  )
}
